import { useEffect, useState } from 'react';

import { FEATURE_FLAGS } from '../common/context/FlagsContext';
import { useFeatureFlagsValue } from '../common/context/FlagsValueContext';
import { getFeaturesByClientId } from '../utils/getFeaturesByClientId';

export function useIdxApiEnabled() {
  const [idxApiEnabled, setIdxApiEnabled] = useState(false);
  const flagsContext = useFeatureFlagsValue();
  useEffect(() => {
    const { isIdxApiEnabled } = getFeaturesByClientId();
    const enabled =
      flagsContext?.flags?.find(v => v?.flagKey === FEATURE_FLAGS.OKTA_IDX_API.toString())?.flagValue ?? false;
    const isFlagEnabled = enabled === true || enabled === 'true';
    setIdxApiEnabled(isFlagEnabled && isIdxApiEnabled);
  }, [flagsContext]);

  return idxApiEnabled;
}
